<template>
  <v-app>
    <v-main>
      <div v-if="isLoading" class="page-layout">
        <PageLoader />
      </div>
      <Home v-else />
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import PageLoader from "@/components/page-loader.vue";
import Home from '@/pages/home.vue';
import { useAuth0 } from "@auth0/auth0-vue";

const { isLoading } = useAuth0();
</script>
